import DOMPurify from 'dompurify';
import { encodeHtml } from '../utils';

export default (
  text: string,
  doHtmlEncoding: Boolean = false,
  skipSanitization: Boolean = false
): string => {
  text = skipSanitization ? text : DOMPurify.sanitize(text);
  if (doHtmlEncoding) text = encodeHtml(text);
  return text;
};
